import { defineNuxtPlugin } from '#app';
import { useMyUserStore } from '~/stores/user';
import { useMyIlanlarStore } from '~/stores/ilanlar';
export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter();

    // Nuxt'un lifecycle fonksiyonu onBeforeMount içinde store'u kullanıyoruz
    nuxtApp.hook('app:mounted', () => {
        const userStore = useMyUserStore(); // Store'u burada çağırıyoruz
        const ilanlarStore = useMyIlanlarStore();
        router.beforeEach((to, from, next) => {
            // Kullanıcı bilgisi eksikse, profil doldurulmadan devam etme
            if (!userStore.getMe.isBasicInfoCompleted) {
                if (from.path === '/profil/kisisel-bilgilerim' && to.path !== '/giris-yap') {
                    toast.error("Lütfen önce profil bilgilerinizi doldurun");
                    return next(false); // Yönlendirmeyi engelle
                }
            }

            // Giriş sayfasına yönlendirme durumunda, state sıfırlama
            if (to.path === '/giris-yap') {
                userStore.resetState();
            }
            const leavingBlog = from.path.startsWith('/blog') && !to.path.startsWith('/blog');
            const leavingYatirimlar = from.path.startsWith('/yatirimlar') && !to.path.startsWith('/yatirimlar');
            const leavingFirsatlar = from.path.startsWith('/firsatlar') && !to.path.startsWith('/firsatlar');
      
            if (leavingBlog && process.client) {
              localStorage.removeItem('currentPage_blog');
            }
            if(ilanlarStore.getCurrentTab === "future"){
              localStorage.removeItem('currentPage_future');
            }else if(ilanlarStore.getCurrentTab === "advantageous"){
              localStorage.removeItem('currentPage_advantageous');
            }
            if (leavingYatirimlar && process.client) {
                localStorage.removeItem('currentPage');
            }
            next();
        });
    });
});
